export default __webpack_public_path__ + "static/media/0C9D9E87-022F-401F-B3DF-5824D69B552F_1_105_c.321f6af8.jpeg";